var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgH1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.875 11.925V26.4937C34.875 27.3946 34.1446 28.125 33.2437 28.125H27.9939C27.4672 28.125 27.0071 27.7367 26.9543 27.2125C26.4974 22.669 22.6645 19.125 18 19.125C13.3355 19.125 9.50265 22.669 9.04567 27.2125C8.99291 27.7367 8.53279 28.125 8.00606 28.125H2.75625C1.85535 28.125 1.125 27.3946 1.125 26.4937V11.925C1.125 11.5538 1.42875 11.25 1.8 11.25H34.2C34.5713 11.25 34.875 11.5538 34.875 11.925Z",
    fill: "#FE7320"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1948 9H1.80517C1.42954 9 1.125 8.69546 1.125 8.31983V6.13609C1.125 5.23249 1.85749 4.5 2.76109 4.5H33.2388C34.1425 4.5 34.875 5.23249 34.875 6.13609V8.31983C34.875 8.69546 34.5705 9 34.1948 9Z",
    fill: "#FE7320"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2087 23.8388C23.0512 23.6475 21.06 21.375 18 21.375C14.2763 21.375 11.25 24.4013 11.25 28.125C11.25 31.8488 14.2763 34.875 18 34.875C21.7238 34.875 24.75 31.8488 24.75 28.125C24.75 25.8863 23.5575 24.255 23.2087 23.8388ZM20.25 29.25H19.125V30.375C19.125 30.9937 18.6188 31.5 18 31.5C17.3812 31.5 16.875 30.9937 16.875 30.375V29.25H15.75C15.1312 29.25 14.625 28.7438 14.625 28.125C14.625 27.5062 15.1312 27 15.75 27H16.875V25.875C16.875 25.2562 17.3812 24.75 18 24.75C18.6188 24.75 19.125 25.2562 19.125 25.875V27H20.25C20.8687 27 21.375 27.5062 21.375 28.125C21.375 28.7438 20.8687 29.25 20.25 29.25Z",
    fill: "#FE7320"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH1);
export default __webpack_public_path__ + "static/media/h1.773a454d43abab6a4aa735b3ead5473c.svg";
export { ForwardRef as ReactComponent };